import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { setTitle } from "../../assorted/setTitle";
import styled from "styled-components";

import CardPage from "../_pages_shared/CardPage";
import Header from "../_pages_shared/Header";
import PageTitle from "../_pages_shared/PageTitle.sc";
import Main from "../_pages_shared/Main.sc";
import ButtonContainer from "../_pages_shared/ButtonContainer.sc";
import Button from "../_pages_shared/Button.sc";

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2em;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;

const SecondaryButton = styled(Button)`
  background-color: #f0f0f0;
  color: #333;

  &:hover {
    background-color: #e0e0e0;
  }
`;

export default function Welcome() {
  const history = useHistory();

  useEffect(() => {
    setTitle("Welcome to Zeeguu");
  }, []);

  function handleHasAccount() {
    history.push("/log_in");
  }

  function handleNewUser() {
    history.push("/invite_code");
  }

  return (
    <CardPage pageWidth={"narrow"} isBackgroundFixed={true}>
      <Header>
        <PageTitle>Welcome to Zeeguu</PageTitle>
      </Header>
      <Main>
        <Subtitle>Do you already have an account?</Subtitle>
        <ButtonGroup>
          <Button onClick={handleHasAccount} className="full-width-btn">
            Yes, log me in
          </Button>
          <SecondaryButton onClick={handleNewUser} className="full-width-btn">
            No, I'm new here
          </SecondaryButton>
        </ButtonGroup>
      </Main>
    </CardPage>
  );
}
